// extracted by mini-css-extract-plugin
export default {"customerInfoForm":"CustomerBillingInfoForm_customerInfoForm__xjDrF","label":"CustomerBillingInfoForm_label__0Yl85","fieldError":"CustomerBillingInfoForm_fieldError__cvWcU"};